import {Component, OnInit, Output, EventEmitter, Input, SimpleChanges} from '@angular/core';
import {products} from '../products';
import {Intercalaire} from '../_models';

@Component({
    selector: 'app-intercalaires',
    templateUrl: './intercalaires.component.html',
    styleUrls: ['./intercalaires.component.scss']
})
export class IntercalairesComponent implements OnInit {

    @Input() intercalaires: Intercalaire[];
    @Input() editingMode: boolean;
    @Input() currentIntercalaire: string;
    @Output() changeEvent = new EventEmitter<string>();
    @Output() createEvent = new EventEmitter<void>();

    currentIntercalaireId: string;

    constructor() {}

    selectIntercalaire(intercalaire) {
        this.changeEvent.emit(intercalaire);
    }

    createIntercalaire() {
        this.createEvent.emit();
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {

        // On the first time we get the intercalaires, we select the first one
        if (this.intercalaires.length && !this.currentIntercalaire) {
            this.currentIntercalaireId = (this.intercalaires[0] as Intercalaire).id;
        }
    }
}
